module.exports = __webpack_public_path__ + "static/img/contact-code.a62c93d9.png";